<template>
    <div class="dialog-advanced-filter">
        <div class="dialog-advanced-filter__header">
            <span class="dialog-advanced-filter__title">
                {{ translate('btn_advanced_filters') }}
            </span>
            <div class="dialog-advanced-filter__action">
                <el-link v-if="hasFilters" @click="$emit('clear')">
                    {{ translate('clear_filters') }}
                </el-link>
                <el-link @click="$emit('handleFilter')">
                    {{ translate('apply_filters') }}
                </el-link>
            </div>
        </div>
        <div class="dialog-advanced-filter__content">
            <el-form>
                <el-collapse v-model="collapseSelected">
                    <el-collapse-item
                        :title="translate('status_label')"
                        name="1"
                    >
                        <el-checkbox-group
                            v-model="filter.status"
                            class="dialog-advanced-filter__content__status"
                        >
                            <el-checkbox label="NAO_ENVIADO">
                                {{ translate('in_progress') }}
                            </el-checkbox>
                            <el-checkbox label="ENVIADO">
                                {{ translate('waiting_approval') }}
                            </el-checkbox>
                            <el-checkbox label="APROVADO">
                                {{ translate('approved') }}
                            </el-checkbox>
                            <el-checkbox label="REPROVADO">
                                {{ translate('rejected') }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('client_label')"
                        name="2"
                    >
                        <el-form-item :label="translate('client_tip')">
                            <el-select
                                v-model="filter.client"
                                style="width: 100%"
                                @change="setClient"
                            >
                                <el-option
                                    :label="client.name"
                                    :value="client.id"
                                    v-for="client in clients"
                                    :key="client.name"
                                >
                                    {{ client.name }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('safra_label')"
                        name="3"
                    >
                        <el-form-item :label="translate('safra_tip')">
                            <el-select
                                v-model="filter.safra"
                                style="width: 100%"
                            >
                                <el-option
                                    :label="safra.descricao"
                                    :value="safra.ano"
                                    v-for="safra in safras"
                                    :key="safra.ano"
                                >
                                    {{ safra.descricao }}
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-collapse-item>
                    <el-collapse-item
                        :title="translate('cultivation_label')"
                        name="4"
                    >
                        <el-checkbox-group
                            v-model="filter.cultivations"
                            class="dialog-advanced-filter__content__cultivation"
                        >
                            <el-checkbox
                                v-for="cultivation in cultivations"
                                :key="cultivation.id"
                                :label="cultivation.codigo"
                            >
                                {{ cultivation.nome }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'dialog-advanced-filters',
    data() {
        return {
            collapseSelected: [1]
        };
    },
    mounted() {
        this.fetchCultivations();
        this.fetchSafras();
        this.fetchClientes();
    },
    computed: {
        ...mapState('traceabilityContractModule', ['filter']),
        ...mapGetters('traceabilityContractModule', {
            cultivations: 'getCultivationTypes',
            clients: 'getClients',
            safras: 'getSafras'
        }),
        hasFilters() {
            return (
                this.filter.contract_number ||
                this.filter.status?.length > 0 ||
                this.filter.client ||
                this.filter.safra ||
                this.filter.cultivations?.length > 0
            );
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', [
            'fetchCultivations',
            'fetchSafras',
            'fetchClientes'
        ]),
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade.messages.main_filters';
            return this.$t(`${base}.${key}`, params);
        },
        setClient(client) {
            this.filter.client_name = this.clients.find(
                (c) => c.id === client
            ).name;
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-advanced-filter {
    width: 100%;

    .dialog-advanced-filter__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dialog-advanced-filter__title {
            font-weight: 500;
            font-size: 16px;
            color: #00413c;
        }

        .dialog-advanced-filter__action {
            display: flex;
            gap: 16px;

            .el-link:first-child {
                color: #e35e58;
                font-size: 14px;
                font-weight: 400;
            }

            .el-link:last-child {
                color: #036be4;
                font-size: 14px;
                font-weight: 400;
            }
        }
    }

    .dialog-advanced-filter__content {
        .dialog-advanced-filter__content__status {
            display: grid;
            grid-template-columns: 1fr 1fr auto;
            gap: 16px;
        }

        .dialog-advanced-filter__content__cultivation {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            gap: 32px;
        }
    }
}
</style>
